module.exports = __webpack_public_path__ + "static/media/47.a35efa55.png";